import throttle from 'lodash/throttle';
import HandleForm from '~scripts/components/forms/forms';

export default function initRequestForm(form) {
  if (!form) {
    return;
  }

  const handleForm = new HandleForm(form);

  const handleSubmit = throttle(() => {
    if (!handleForm.checkValidity()) {
      return;
    }

    handleForm.disableSubmit();

    form.submit();

    window.submitDemoRequestForm && window.submitDemoRequestForm();

    if (window._txq) {
      _txq.push(['track', 'ask_demo']);
    }
  }, 100);

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    handleSubmit();
  });
}
